export default __webpack_public_path__ + "static/media/google.3ef05a9e.svg";